import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import WarehouseDenialCausesList from './warehouseDenialCauses/list';
import EditWarehouseDenialCause from './warehouseDenialCauses/edit';
import ScanningWarehouseDenied from './scanning/warehouseDenied';
import ManualsOrderDetailManager from './manualOrders/detailManager/index';
import ManualsOrdersList from './manualOrders/list/index';
import StoragePendingCars from './storagePending';
import PickingDashboard from './slideShow';
import Scanning from './scanning';
import ShiftsList from './shifts/list';
import EditShift from './shifts/edit';
import ZonesList from './zones/list';
import EditZone from './zones/edit';

export const warehouseDenialCausesRoutes = [
  {
    'component': <WarehouseDenialCausesList />,
    'path': paths.WarehouseDenialCausesList,
  },
  {
    'component': <EditWarehouseDenialCause />,
    'path': paths.EditWarehouseDenialCause,
  },
  {
    'component': <EditWarehouseDenialCause />,
    'path': paths.NewWarehouseDenialCause,
  },
  {
    'component': <ShiftsList />,
    'path': paths.ShiftsList,
  },
  {
    'component': <EditShift />,
    'path': paths.EditShift,
  },
  {
    'component': <EditShift />,
    'path': paths.NewShift,
  },
  {
    'component': <ZonesList />,
    'path': paths.ZonesList,
  },
  {
    'component': <EditZone />,
    'path': paths.EditZone,
  },
  {
    'component': <EditZone />,
    'path': paths.NewZone,
  },
  {
    'component': <Scanning />,
    'path': paths.Scanning,
  },
  {
    'component': <ScanningWarehouseDenied />,
    'path': paths.ScanningWarehouseDenied,
  },
  {
    'component': <StoragePendingCars />,
    'path': paths.StoragePendingCars,
  },
  {
    'component': <ManualsOrdersList />,
    'path': paths.ManualsOrdersList,
  },
  {
    'component': <ManualsOrderDetailManager />,
    'path': paths.ManualsOrderDetailManager,
  },
  {
    'component': <PickingDashboard />,
    'path': paths.PickingDashboard,
  },
];
